
import ophtalmic from '../../public/img/ophtalmic.svg';
import oralHygiene from '../../public/img/oral-hygiene.svg';
import vaccines from '../../public/img/vaccines.svg';
import dermatologic from '../../public/img/dermatologic.svg';
import calculators from '../../public/img/calculators.svg';
import drugs from '../../public/img/drugs.svg';
import supplements from '../../public/img/supplements.svg';
import foods from '../../public/img/foods.svg';
import interactions from '../../public/img/interactions.svg';
import diseases from '../../public/img/diseases.svg';
import algorithms from '../../public/img/algorithms.svg';
import ddx from '../../public/img/ddx.svg';
const sections = [
    {
        name: "Diagnósticos Diferenciais",
        module: "ddx",
        action: "openDdx",
        image: ddx,
        new: true
    },
    {
        name: "Interações Medicamentosas",
        method: "openInteractions",
        image: interactions,
        new: true
    },
    {
        name: "Algoritmos",
        module: "topics",
        action: "openTopic",
        id: "1655150373366",
        image: algorithms,
        new: true,
        subtopic: process.env.VUE_APP_ALGORITHMS_SUBTOPIC
    },
    {
        name: "Doenças",
        // module: "topics",
        // action: "openTopic",
        module: "preferences",
        action: "postFakeDoorClick",
        id: "1655994505075",
        image: diseases,
        new: true
    },
    {
        name: "Medicamentos",
        image: drugs,
        categoryId: 1
    },
    {
        name: "Calculadoras e Escores",
        module: "calculators",
        action: "openCalculators",
        image: calculators,
        categoryId: 7
    },
    {
        name: "Suplementos e Nutracêuticos",
        image: supplements,
        categoryId: 6
    },
    {
        name: "Rações",
        module: "topics",
        action: "openTopic",
        id: "foods",
        image: foods,
    },
    {
        name: "Dermatológicos Tópicos",
        image: dermatologic,
        categoryId: 4
    },
    {
        name: "Vacinas e Biológicos",
        image: vaccines,
        categoryId: 2
    },
    {
        name: "Higiene Oral",
        image: oralHygiene,
        categoryId: 3
    },
    {
        name: "Agentes Oftalmológicos",
        image: ophtalmic,
        categoryId: 5
    },
];
const getSection = (id, section) => {
    if (!section && !!id) {
        return sections.find((s) => {
            return (
                !!s.categoryId &&
                s.categoryId.toString() == `${id}`.trim()
            );
        });
    }
    return section;
}
const goToSection = async ({ id, dispatch, section }) => {
    section = getSection(id, section);
    if (section && !!section.categoryId) {
        const path = !!section.categoryId ? `/items?category=${section.categoryId}` : `/topics/${section.id}`;
        dispatch('general/routePathRedirect', { path }, { root: true })
    } else if (section && !!section.action) {
        dispatch(`${section.module}/${section.action}`, section.id, { root: true })
    }
}

export default {
    getSection,
    goToSection,
    sections
}